module.exports = __webpack_public_path__ + "static/media/screenshot2.9525a938.png";